module.exports = __webpack_public_path__ + "media/images/official/bnr_event_pc-d26d1b6f3dab40f2309a83be70819c9e.jpg";